// Fix missing viewBox on SVGs using <use> references
(function () {
  function fixSvgViewBox(root) {
    (root || document).querySelectorAll("svg:not([viewBox])").forEach(function (svg) {
      var use = svg.querySelector("use");
      if (!use) return;
      var href = use.getAttribute("href") || use.getAttribute("xlink:href");
      if (!href || !href.startsWith("#")) return;
      try {
        var symbol = document.querySelector(href);
        if (symbol && symbol.getAttribute("viewBox")) {
          svg.setAttribute("viewBox", symbol.getAttribute("viewBox"));
        }
      } catch (e) {}
    });
  }

  // Initial pass
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { fixSvgViewBox(); });
  } else {
    fixSvgViewBox();
  }

  // Only react to NEWLY ADDED svg elements, not every text mutation
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === "svg" || (node.querySelector && node.querySelector("svg"))) {
          fixSvgViewBox(node.parentNode || node);
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();


/* ----------------------------------------------------------
   Livechat – HubSpot button with id="openLiveChat"
---------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var liveChatButton = document.getElementById('openLiveChat');
  if (!liveChatButton) return;

  liveChatButton.addEventListener('click', function () {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.open();
    } else {
      console.log('HubSpot Conversations is not loaded.');
    }
  });
});


/* ----------------------------------------------------------
   Lottie layout & loading
---------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var containers = [
    document.getElementById('lottie-content-container'),
    document.getElementById('lottie-content-container-product'),
  ];

  containers.forEach(function (container) {
    if (!container) return;

    var textElement = container.querySelector('#lottie-text');
    var animationContainer = container.querySelector(
      '#lottie-animation-container'
    );
    if (!textElement || !animationContainer) return;

    function layoutElements() {
      var isMobile = window.innerWidth <= 768;

      if (isMobile) {
        container.style.display = 'block';
        textElement.style.width = '100%';
        animationContainer.style.width = '100%';
        animationContainer.style.height = '200px';
        animationContainer.style.marginTop = '20px';
      } else {
        container.style.display = 'flex';
        container.style.alignItems = 'flex-start';
        textElement.style.width = '66%';
        animationContainer.style.width = '33%';
        animationContainer.style.height = '300px';
        animationContainer.style.marginTop = '-40px';
      }

      if (animationContainer.lottieAnimation) {
        animationContainer.lottieAnimation.resize();
      }
    }

    function initLottie() {
      animationContainer.lottieAnimation = lottie.loadAnimation({
        container: animationContainer,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'https://cdn.shopify.com/s/files/1/0754/0388/6933/files/Animation_-_1726733933844.json?v=1726737722',
      });
    }

    if (typeof lottie === 'undefined') {
      var script = document.createElement('script');
      script.src =
        'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.9.6/lottie.min.js';
      script.onload = function () {
        initLottie();
        layoutElements();
      };
      document.head.appendChild(script);
    } else {
      initLottie();
      layoutElements();
    }

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(layoutElements, 150);
    });
  });
});


